"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = union;

var _index = require("../../../lib-vendor/internmap/src/index.js");

function union(...others) {
  const set = new _index.InternSet();

  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }

  return set;
}


//////////////////
// WEBPACK FOOTER
// ./~/victory-vendor/lib-vendor/d3-array/src/union.js
// module id = ./node_modules/victory-vendor/lib-vendor/d3-array/src/union.js
// module chunks = 1